export const siteSearchTabs = [
  'All',
  'Pages',
  'Sub-Zero Products',
  'Wolf Products',
  'News and Events'
];

export const ENTER_KEY = 'Enter';
